/**
 * An overtime pay type below the law's minimum (AML §10-6 (11): at least 40 % on top of the hourly
 * wage). Overtime is a type with a weekly-hours threshold rule; a percent below 40 is flagged, an
 * amount per hour cannot be compared without the wage, so it is left alone.
 */
import type { ApiPayrollType, ApiRateRule } from '@/api/data';

export const overtimeBelowLaw = (
  p: Pick<ApiPayrollType, 'rateType' | 'value'>,
  rules: Pick<ApiRateRule, 'threshold'>[],
) =>
  // a threshold of 0 is no weekly-hours rule, as the server and the pay engine read it
  rules.some((r) => r.threshold != null && Number(r.threshold) > 0) &&
  p.rateType === 'percent' &&
  Number(p.value) < 40;
